import { render, staticRenderFns } from "./CardOverlay.vue?vue&type=template&id=0ce7bade&"
import script from "./CardOverlay.vue?vue&type=script&lang=js&"
export * from "./CardOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports